<template>
  <div class="create-edit-contact-point-or-sale-card">
    <div class="card__header d-none d-md-block">
      <span class="card__header--topic">{{ cardTitle }}</span>
    </div>
    <div class="card__body">
      <div class="row mt-2">
        <div class="col-12 col-md-6 mt-md-4 flex-row">
          <div class="profile-picture-container">
            <b-img
              v-if="image || imageSrc"
              :src="imageSrc"
              rounded
              class="profile-picture"
            />
            <b-img
              v-else
              v-bind="defaultPicture"
              rounded
              blank-color="#efefef"
            />
          </div>
          <atom-file-input
            v-model="image"
            title="Select Profile Picture"
            :isDisable="!hasEditPermission"
            :isOnlyImage="true"
            class="mt-1 mb-1 mb-md-0"
          ></atom-file-input>
        </div>
        <div class="col-12 col-md-6 mt-1 mb-1 mb-md-0 flex-row align-self-end">
          <span class="text-topic--medium">Personal Data</span>
          <div class="row mt-1">
            <div class="col-12 col-md-6">
              <atom-input
                v-model="currentContactPointOrSaleDetail.firstName"
                title="First Name"
                placeholder="First Name"
                :isAsterisk="true"
                :isError="isErrorAtContactFirstName"
                :errorMessage="errorMessageAtInput"
                :isDisable="!hasEditPermission"
              ></atom-input>
            </div>
            <div class="col-12 col-md-6 mt-1 mt-md-0">
              <atom-input
                v-model="currentContactPointOrSaleDetail.lastName"
                title="Last Name"
                placeholder="Last Name"
                :isAsterisk="true"
                :isError="isErrorAtContactLastName"
                :errorMessage="errorMessageAtInput"
                :isDisable="!hasEditPermission"
              ></atom-input>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-12 col-md-6">
              <atom-select
                v-model="currentContactPointOrSaleDetail.idType"
                title="Identification Type"
                placeholder="Select Type"
                label="name"
                :isAsterisk="true"
                :isClearable="false"
                :isAppendToBody="false"
                :isEnableProper="false"
                :isError="isErrorAtSelectIdType"
                :errorMessage="errorMessageAtSelector"
                :option="idTypeOption"
                :isDisable="!hasEditPermission"
              ></atom-select>
            </div>
            <div class="col-12 col-md-6 mt-1 mt-md-0">
              <atom-input
                v-model="currentContactPointOrSaleDetail.idOrPassportNumber"
                title="ID/Passport Number"
                placeholder="ID/Passport Number"
                :isDisable="
                  !currentContactPointOrSaleDetail.idType || !hasEditPermission
                "
                :isAsterisk="true"
                :isError="isErrorAtContactIdOrPassportNumber"
                :errorMessage="errorMessageAtInput"
              ></atom-input>
            </div>
          </div>
          <div class="mt-1">
            <atom-select
              v-model="currentContactPointOrSaleDetail.role"
              title="Role"
              placeholder="Select Role"
              label="name"
              :isAsterisk="true"
              :isClearable="false"
              :isDisable="isDisableSelectRole || !hasEditPermission"
              :isAppendToBody="false"
              :isEnableProper="false"
              :isError="isErrorAtSelectRole"
              :errorMessage="errorMessageAtSelector"
              :option="roleOption"
            ></atom-select>
          </div>
        </div>
      </div>
      <div class="row mt-1 mt-md-3 mb-2">
        <div class="col-12 col-md-6 mb-1 mb-md-0 flex-row">
          <span class="text-topic--medium">Email List</span>
          <div class="mt-1">
            <atom-input
              v-model="currentContactPointOrSaleDetail.email.primary.email"
              title="Email 1"
              placeholder="Email"
              :isAsterisk="true"
              :isError="isErrorAtContactEmailPrimary"
              :errorMessage="errorMessageAtInput"
              :isDisable="!hasEditPermission"
            ></atom-input>
          </div>
          <div class="mt-1">
            <atom-input
              v-model="currentContactPointOrSaleDetail.email.secondary.email"
              title="Email 2"
              placeholder="Email"
              :isError="isErrorAtContactEmailSecondary"
              :errorMessage="errorMessageAtInput"
              :isDisable="!hasEditPermission"
            ></atom-input>
          </div>
          <div class="mt-1">
            <atom-input
              v-model="currentContactPointOrSaleDetail.email.third.email"
              title="Email 3"
              placeholder="Email"
              :isError="isErrorAtContactEmailThird"
              :errorMessage="errorMessageAtInput"
              :isDisable="!hasEditPermission"
            ></atom-input>
          </div>
        </div>
        <div class="col-12 col-md-6 mt-1 mt-md-0 flex-row">
          <span class="text-topic--medium">Phone Number List</span>
          <div class="mt-1">
            <atom-input
              v-model="currentContactPointOrSaleDetail.phone.primary.phone"
              title="Phone Number 1"
              placeholder="Phone Number"
              :isAsterisk="true"
              :isError="isErrorAtContactPhoneNumberPrimary"
              :errorMessage="errorMessageAtInput"
              :isDisable="!hasEditPermission"
            ></atom-input>
          </div>
          <div class="mt-1">
            <atom-input
              v-model="currentContactPointOrSaleDetail.phone.secondary.phone"
              title="Phone Number 2"
              placeholder="Phone Number"
              :isError="isErrorAtContactPhoneNumberSecondary"
              :errorMessage="errorMessageAtInput"
              :isDisable="!hasEditPermission"
            ></atom-input>
          </div>
          <div class="mt-1">
            <atom-input
              v-model="currentContactPointOrSaleDetail.phone.third.phone"
              title="Phone Number 3"
              placeholder="Phone Number"
              :isError="isErrorAtContactPhoneNumberThird"
              :errorMessage="errorMessageAtInput"
              :isDisable="!hasEditPermission"
            ></atom-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const base64Encode = (data) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(data)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })

import { BImg } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomFileInput from "@/components/atoms/AtomFileInput.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
export default {
  name: "MoleculeCreateEditContactPointOrSale",
  components: {
    AtomButton,
    AtomFileInput,
    AtomInput,
    AtomSelect,
    BImg,
  },
  props: {
    cardTitle: {
      type: String,
      required: true,
    },
    isValidateContactTrigger: {
      type: Boolean,
      required: true,
      default: false,
    },
    profilePicture: {
      type: File,
      required: false,
    },
    hasEditPermission: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Object,
      required: true,
    },
  },
  emits: [
    "onUpdateProfilePicture",
    "onUpdateErrorAtCreateEditContactPointOrSale",
  ],
  data() {
    return {
      modalId: null,
      defaultPicture: { blank: true, width: 150, height: 150 },
      errorMessageAtInput: "Please enter valid data",
      errorMessageAtSelector: "Please select data",
      image: null,
      imageSrc: null,
      isDataChange: false,
      roleOption: ["Customer", "Sale"],
      idTypeOption: ["ID", "Passport Number"],
    }
  },
  computed: {
    currentContactPointOrSaleDetail: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    contactPointOrSaleId() {
      return this.$route?.params?.id
    },
    isDisableSelectRole() {
      return !this.isEmptyString(this.contactPointOrSaleId)
    },
    isErrorAtContactFirstName() {
      return this.isValidateContactTrigger
        ? this.isEmptyString(this.currentContactPointOrSaleDetail.firstName)
        : false
    },
    isErrorAtContactLastName() {
      return this.isValidateContactTrigger
        ? this.isEmptyString(this.currentContactPointOrSaleDetail.lastName)
        : false
    },
    isErrorAtSelectIdType() {
      return this.isValidateContactTrigger
        ? this.isEmptyValue(this.currentContactPointOrSaleDetail.idType)
        : false
    },
    isErrorAtContactIdOrPassportNumber() {
      return this.isValidateContactTrigger
        ? this.isEmptyString(
            this.currentContactPointOrSaleDetail.idOrPassportNumber
          )
        : false
    },
    isErrorAtSelectRole() {
      return this.isValidateContactTrigger
        ? this.isEmptyValue(this.currentContactPointOrSaleDetail.role)
        : false
    },
    isErrorAtContactEmailPrimary() {
      return this.isValidateContactTrigger
        ? this.isEmptyString(
            this.currentContactPointOrSaleDetail.email.primary.email
          ) ||
            this.isInvalidEmail(
              this.currentContactPointOrSaleDetail.email.primary.email
            )
        : false
    },
    isErrorAtContactEmailSecondary() {
      return this.isValidateContactTrigger
        ? this.isInvalidEmail(
            this.currentContactPointOrSaleDetail.email.secondary.email
          ) &&
            !this.isEmptyString(
              this.currentContactPointOrSaleDetail.email.secondary.email
            )
        : false
    },
    isErrorAtContactEmailThird() {
      return this.isValidateContactTrigger
        ? this.isInvalidEmail(
            this.currentContactPointOrSaleDetail.email.third.email
          ) &&
            !this.isEmptyString(
              this.currentContactPointOrSaleDetail.email.third.email
            )
        : false
    },
    isErrorAtContactPhoneNumberPrimary() {
      return this.isValidateContactTrigger
        ? this.isEmptyString(
            this.currentContactPointOrSaleDetail.phone.primary.phone
          )
        : // ||
          //   this.isInvalidPhoneNumber(
          //     this.currentContactPointOrSaleDetail.phone.primary.phone
          //   )
          false
    },
    isErrorAtContactPhoneNumberSecondary() {
      return false
      // return this.isValidateContactTrigger
      //   ? this.isInvalidPhoneNumber(
      //       this.currentContactPointOrSaleDetail.phone.secondary.phone
      //     ) && !this.isEmptyString(this.currentContactPointOrSaleDetail.phone.secondary.phone)
      //   : false
    },
    isErrorAtContactPhoneNumberThird() {
      return false
      // return this.isValidateContactTrigger
      //   ? this.isInvalidPhoneNumber(
      //       this.currentContactPointOrSaleDetail.phone.third.phone
      //     ) && !this.isEmptyString(this.currentContactPointOrSaleDetail.phone.third.phone)
      //   : false
    },
    isErrorOccur() {
      return (
        this.isErrorAtContactFirstName ||
        this.isErrorAtContactLastName ||
        this.isErrorAtSelectIdType ||
        this.isErrorAtContactIdOrPassportNumber ||
        this.isErrorAtSelectRole ||
        this.isErrorAtContactEmailPrimary ||
        this.isErrorAtContactEmailSecondary ||
        this.isErrorAtContactEmailThird ||
        this.isErrorAtContactPhoneNumberPrimary ||
        this.isErrorAtContactPhoneNumberSecondary ||
        this.isErrorAtContactPhoneNumberThird
      )
    },
  },
  watch: {
    image(newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then((value) => {
              this.imageSrc = value
              this.$emit("onUpdateProfilePicture", this.image)
            })
            .catch(() => {
              this.imageSrc = null
            })
        } else {
          this.imageSrc = null
        }
      }
    },
    isErrorOccur: {
      immediate: true,
      handler() {
        this.$emit(
          "onUpdateErrorAtCreateEditContactPointOrSale",
          this.isErrorOccur
        )
      },
    },
    "currentContactPointOrSaleDetail.profilePicture": {
      deep: true,
      handler() {
        if (this.currentContactPointOrSaleDetail.profilePicture) {
          this.imageSrc = this.currentContactPointOrSaleDetail.profilePicture
        }
      },
    },
  },

  methods: {
    hasValue(input) {
      return input !== null && input !== undefined && input.length !== 0
    },

    isEmptyValue(input) {
      return input === null || input === undefined || input.length === 0
    },

    isEmptyString(input) {
      return input ? input.trim() === "" : true
    },

    isInvalidEmail(email) {
      const emailFormat = /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
      return this.isEmptyString(email) ? false : !emailFormat.test(email)
    },

    isInvalidPhoneNumber(phoneNumber) {
      const phoneFormat = /^0[0-9]{8,9}$/
      return this.isEmptyString(phoneNumber)
        ? false
        : !phoneFormat.test(phoneNumber)
    },
  },
}
</script>

<style lang="scss" scoped>
.create-edit-contact-point-or-sale-card ::v-deep input.vs__search::placeholder {
  color: #b9b9c3;
}

.create-edit-contact-point-or-sale-card {
  padding: 21px;
}

.card__header--topic {
  font-weight: 500;
  font-size: 18px;
}

.text-topic--medium {
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  color: #5e5873;
}

.profile-picture-container {
  display: flex;
  justify-content: center;
  height: 150px;
}

.profile-picture {
  width: 150px;
  height: 150px;
}
</style>
